// extracted by mini-css-extract-plugin
module.exports = {"grid":"report-grid_grid__3oRz3","minWidth":"report-grid_minWidth__202mj"};